// Split "🍛 South Asian" -> {id, emoji: "🍛", label: "South Asian"}, matching the
// option format returned by REG_OPTIONS_DETAILS.
export const parseOption = (item) => {
  const name = (item?.name || '').trim();
  const spaceIdx = name.indexOf(' ');
  if (spaceIdx > 0 && name.charCodeAt(0) > 127) {
    return { id: item.id, emoji: name.slice(0, spaceIdx), label: name.slice(spaceIdx + 1).trim() };
  }
  return { id: item.id, emoji: '•', label: name };
};

// Pulls a human-readable message out of the apiHandler response contract:
// success shape is res.data.response, failure shape is the raw axios error
// (res.response.data...) since apiHandler returns the caught error as-is.
// Some endpoints return AdonisJS-style validation errors instead
// ({errors: [{field, message}]}) rather than the usual {data:{message}} shape.
export const apiErrorMessage = (res, fallback) =>
  res?.response?.data?.data?.message ||
  res?.response?.data?.message ||
  res?.response?.data?.errors?.[0]?.message ||
  fallback;

export const apiSucceeded = (res) => res?.data?.response?.status === 200;
